export enum AppRole {
	PRESIGN = "presign",
	REGISTERED = "registered",
}
